/**
 * 
 * @param {array} rates 
 */
export default function sortRatesByFeaturedAndValue(rates) {
    return rates.slice().sort((rate1, rate2) => {
        if (rate1.isFeatured && !rate2.isFeatured) {
            return -1;
        } else if (!rate1.isFeatured && rate2.isFeatured) {
            return 1;
        } else {
            return rate1.value - rate2.value;
        }
    });
}